module.exports = __webpack_public_path__ + "img/step-13.57d190ec.jpg";